export const ACTION_DEMO_START = 'DEMO_START';

export function start(event, userId) {
    return {
        type: ACTION_DEMO_START,
        eventId: event.id,
        event,
        userId,
    };
}
